import { memo } from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./app/auth";
import { CurrencyProvider } from "./app/currency";
import { SettingsProvider } from "./app/settings";
import { UserContextProvider } from "./app/user";
import { AdvancedExchangeContextProvider } from "./contexts/AdvancedExchangeContext";
import { CurrentItemBeingReturnedContextProvider } from "./contexts/CurrentItemBeingReturnedContext";
import { ExchangeTypeContextProvider } from "./contexts/ExchangeTypeContext";
import { FlowStepContextProvider } from "./contexts/FlowStepContext";
import { ItemsReadyForReturnContextProvider } from "./contexts/ItemsReadyForReturnContext";
import { PickupContextProvider } from "./contexts/PickupContext";

export const Root = memo(() => {
  return (
    <SettingsProvider>
      <AuthProvider>
        <UserContextProvider>
          <AdvancedExchangeContextProvider>
            <PickupContextProvider>
              <CurrentItemBeingReturnedContextProvider>
                <ItemsReadyForReturnContextProvider>
                  <CurrencyProvider>
                    <ExchangeTypeContextProvider>
                      <FlowStepContextProvider>
                        <Outlet />
                      </FlowStepContextProvider>
                    </ExchangeTypeContextProvider>
                  </CurrencyProvider>
                </ItemsReadyForReturnContextProvider>
              </CurrentItemBeingReturnedContextProvider>
            </PickupContextProvider>
          </AdvancedExchangeContextProvider>
        </UserContextProvider>
      </AuthProvider>
    </SettingsProvider>
  );
});
